import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Modal, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Authorization } from "../../../Context/Authorization";

const AddPermissions = ({ onClose, onAddPermission }) => {
  const [permissionName, setPermissionName] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({});
  const [submitMessage, setSubmitMessage] = useState("");
  const Api = process.env.REACT_APP_API;

  const validateForm = () => {
    const newErrors = {};
    if (!permissionName) {
      newErrors.permissionName = "Permission name is required";
    }
    if (!description) {
      newErrors.description = "Description is required";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fix the errors in the form");
      return;
    }
    setSubmitMessage("New Permission Successfully!");

    const formData = {
      permissionName,
      description,
    };

    try {
      const Confiq = Authorization();
      const response = await fetch(`${Api}/api/users/permissions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...Confiq.headers,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        toast.success("Added Successfully");
        onAddPermission(result);
        onClose(); // Close the popup after successful form submission
      } else {
        console.error("Error submitting form:", response.statusText);
        toast.error("Error submitting form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form");
    }
  };

  return (
    <div className="stateForm">
      <Modal show onHide={onClose}>
        {submitMessage && <Alert variant="info">{submitMessage}</Alert>}

        <Modal.Header>
          <Modal.Title>Add Permission</Modal.Title>
          <Button
            variant="outline-danger"
            onClick={onClose}
            style={{ marginLeft: "auto" }}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formpermissionName">
              <Form.Label>Permission Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Permission name"
                value={permissionName}
                onChange={(e) => setPermissionName(e.target.value)}
                isInvalid={!!errors.permissionName}
              />
              <Form.Control.Feedback type="invalid">
                {errors.permissionName}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formdescription">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Description of Permission"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                isInvalid={!!errors.description}
              />
              <Form.Control.Feedback type="invalid">
                {errors.description}
              </Form.Control.Feedback>
            </Form.Group>
            <Button type="submit">Submit</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddPermissions;
